/** The orders module's part of the admin dashboard (`dashboard.tiles` slot): today's sales and orders. */

import { useQuery } from "@tanstack/react-query";

import { adminOrdersSummary } from "@motolynk/api-client";
import { useTranslation } from "@motolynk/i18n";
import { formatMoney, KpiTile } from "@motolynk/ui";

function useSummary() {
  return useQuery({
    queryKey: ["admin", "orders", "summary"],
    queryFn: async () => (await adminOrdersSummary()).data,
  });
}

export function SalesTile() {
  const { t } = useTranslation("orders");
  const summary = useSummary().data;
  return (
    <KpiTile
      tone="dark"
      icon="trending"
      label={t("dashboard.sales")}
      value={summary ? formatMoney(summary.sales_today) : "—"}
    />
  );
}

export function OrdersTile() {
  const { t } = useTranslation("orders");
  const summary = useSummary().data;
  return (
    <KpiTile
      icon="cart"
      label={t("dashboard.orders")}
      value={summary ? summary.orders_today : "—"}
      hint={summary ? t("dashboard.awaiting", { count: summary.awaiting_payment }) : undefined}
    />
  );
}
